import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { calculateOverlay } from "../../../utils";

var BannerBodyInlineStyles = /*#__PURE__*/function () {
  function BannerBodyInlineStyles() {
    _classCallCheck(this, BannerBodyInlineStyles);
  }

  _createClass(BannerBodyInlineStyles, null, [{
    key: "bodyContainer",
    value: function bodyContainer(_ref) {
      var type = _ref.layout.type,
          _ref$design = _ref.design,
          bg = _ref$design.bg,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          padding = _ref.bodyDesign.padding,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      var style = {
        background: bg,
        // Top / Bottom padding is applied in leftSide and rightSide containers
        padding: padding.map(function (p, i) {
          return "".concat(i === 0 || i === 2 ? 0 : p, "px");
        }).join(" "),
        lineHeight: 1.4
      };

      if (type === "dialog" && borderWidth > 0) {
        style.borderLeft = "".concat(borderWidth, "px solid ").concat(borderColor);
        style.borderRight = style.borderLeft;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-body-container",
        style: style
      };
    }
  }, {
    key: "body",
    value: function body(_ref2) {
      var _ref2$layout = _ref2.layout,
          type = _ref2$layout.type,
          bannerMaxWidth = _ref2$layout.bannerMaxWidth,
          individualLayout = _ref2.individualLayout,
          antiAdBlocker = _ref2.customCss.antiAdBlocker,
          individualPrivacyOpen = _ref2.individualPrivacyOpen;
      var style = {
        transition: "width 500ms, max-width 500ms",
        maxWidth: type === "banner" ? +(individualPrivacyOpen && !individualLayout.inheritBannerMaxWidth ? individualLayout.bannerMaxWidth : bannerMaxWidth) : undefined,
        margin: "auto"
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-body",
        style: style
      };
    }
  }, {
    key: "description",
    value: function description(_ref3) {
      var fontSize = _ref3.design.fontSize,
          _ref3$bodyDesign = _ref3.bodyDesign,
          descriptionInheritFontSize = _ref3$bodyDesign.descriptionInheritFontSize,
          descriptionFontSize = _ref3$bodyDesign.descriptionFontSize,
          descriptionTextAlign = _ref3.individualLayout.descriptionTextAlign,
          antiAdBlocker = _ref3.customCss.antiAdBlocker,
          individualPrivacyOpen = _ref3.individualPrivacyOpen;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-description",
        style: {
          lineHeight: 1.5,
          fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
          textAlign: individualPrivacyOpen ? descriptionTextAlign : undefined
        }
      };
    }
  }, {
    key: "teachingsSeparator",
    value: function teachingsSeparator(_ref4) {
      var borderRadius = _ref4.layout.borderRadius,
          _ref4$bodyDesign = _ref4.bodyDesign,
          teachingsSeparatorActive = _ref4$bodyDesign.teachingsSeparatorActive,
          teachingsSeparatorWidth = _ref4$bodyDesign.teachingsSeparatorWidth,
          teachingsSeparatorHeight = _ref4$bodyDesign.teachingsSeparatorHeight,
          teachingsSeparatorColor = _ref4$bodyDesign.teachingsSeparatorColor,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-teachings-separator",
        style: {
          marginTop: 7,
          display: "inline-block",
          maxWidth: "100%",
          borderRadius: +borderRadius,
          width: +teachingsSeparatorWidth,
          height: teachingsSeparatorActive ? +teachingsSeparatorHeight : 0,
          background: teachingsSeparatorColor
        }
      };
    }
  }, {
    key: "teaching",
    value: function teaching(_ref5) {
      var _ref5$bodyDesign = _ref5.bodyDesign,
          teachingsInheritTextAlign = _ref5$bodyDesign.teachingsInheritTextAlign,
          teachingsTextAlign = _ref5$bodyDesign.teachingsTextAlign,
          teachingsInheritFontSize = _ref5$bodyDesign.teachingsInheritFontSize,
          teachingsFontSize = _ref5$bodyDesign.teachingsFontSize,
          teachingsInheritFontColor = _ref5$bodyDesign.teachingsInheritFontColor,
          teachingsFontColor = _ref5$bodyDesign.teachingsFontColor,
          antiAdBlocker = _ref5.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-teachings",
        style: {
          marginTop: 7,
          display: "inline-block",
          textAlign: teachingsInheritTextAlign ? undefined : teachingsTextAlign,
          fontSize: teachingsInheritFontSize ? undefined : +teachingsFontSize,
          color: teachingsInheritFontColor ? undefined : teachingsFontColor
        }
      };
    }
  }, {
    key: "historySelect",
    value: function historySelect(_ref6) {
      var _ref6$design = _ref6.design,
          fontSize = _ref6$design.fontSize,
          fontColor = _ref6$design.fontColor,
          _ref6$bodyDesign = _ref6.bodyDesign,
          descriptionInheritFontSize = _ref6$bodyDesign.descriptionInheritFontSize,
          descriptionFontSize = _ref6$bodyDesign.descriptionFontSize,
          antiAdBlocker = _ref6.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-history-select",
        style: {
          fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
          background: "transparent",
          border: 0,
          borderBottom: "1px solid ".concat(calculateOverlay(fontColor, 50))
        }
      };
    }
  }, {
    key: "dottedGroups",
    value: function dottedGroups(_ref7) {
      var antiAdBlocker = _ref7.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-dotted-groups",
        style: {
          marginTop: 10,
          lineBreak: "anywhere",
          lineHeight: 2
        }
      };
    }
  }, {
    key: "dottedGroupItem",
    value: function dottedGroupItem(_ref8) {
      var fontSize = _ref8.design.fontSize,
          _ref8$bodyDesign = _ref8.bodyDesign,
          dottedGroupsInheritFontSize = _ref8$bodyDesign.dottedGroupsInheritFontSize,
          dottedGroupsFontSize = _ref8$bodyDesign.dottedGroupsFontSize;
      return {
        className: undefined,
        style: {
          paddingRight: 10,
          fontSize: dottedGroupsInheritFontSize ? +fontSize : +dottedGroupsFontSize,
          whiteSpace: "nowrap"
        }
      };
    }
  }, {
    key: "dottedGroupBullet",
    value: function dottedGroupBullet(_ref9) {
      var dottedGroupsBulletColor = _ref9.bodyDesign.dottedGroupsBulletColor;
      return {
        className: undefined,
        style: {
          color: dottedGroupsBulletColor
        }
      };
    }
  }]);

  return BannerBodyInlineStyles;
}();

export { BannerBodyInlineStyles };